'use client';

import { cn } from '@/lib/utils';

interface CarouselDotsProps {
  total: number;
  activeIndex: number;
  onDotClick?: (index: number) => void;
  className?: string;
}

export function CarouselDots({ total, activeIndex, onDotClick, className = '' }: CarouselDotsProps) {
  if (total <= 1) return null;

  return (
    <div className={cn('flex justify-center gap-2', className)}>
      {Array.from({ length: total }, (_, index) => (
        <button
          key={index}
          onClick={() => onDotClick?.(index)}
          className={cn(
            'h-1.5 rounded-full transition-all duration-300 cursor-pointer',
            index === activeIndex
              ? 'w-6 bg-gradient-to-r from-[#d4a853] to-[#e8c679]'
              : 'w-1.5 bg-slate-700/50 hover:bg-slate-600'
          )}
          aria-label={`Go to slide ${index + 1}`}
        />
      ))}
    </div>
  );
}
